var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8865,
    cy: 12.9424,
    rx: 12.603,
    ry: 12.5,
    fill: "#DFAD17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3634 8.56573C10.5103 8.43122 10.7485 8.43122 10.8954 8.56573L15.4099 12.6989C15.5568 12.8334 15.5568 13.0515 15.4099 13.186L10.8954 17.3192C10.7485 17.4537 10.5103 17.4537 10.3634 17.3192C10.2164 17.1847 10.2164 16.9666 10.3634 16.8321L14.6119 12.9425L10.3634 9.05283C10.2164 8.91832 10.2164 8.70023 10.3634 8.56573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowService);
export default __webpack_public_path__ + "static/media/ArrowService.c218ab441f061ab595a06110be3e4acc.svg";
export { ForwardRef as ReactComponent };